module.exports = __webpack_public_path__ + "static/media/2.0b628e06.svg";